import { Link } from "react-router-dom";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "Courses", path: "/courses" },
  { label: "Book Now", path: "/booking#reserve-spot" },
  { label: "About Us", path: "/about" },
  { label: "Reviews", path: "/reviews" },
  { label: "Group Training", path: "/group-training" },
  { label: "Referral Program", path: "/referral" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

const courses = [
  "BLS Certification",
  "BLS Renewal",
  "ACLS Certification",
  "PALS Certification",
  "CPR / AED",
  "First Aid",
  "BLS Instructor Course",
  "Group Training",
];

export default function Footer() {
  return (
    <footer className="bg-brand-black text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/0bc8c1a5-8349-4da7-bc3f-8127b6f3ae55.png"
              alt="Cardiocraft CPR"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Kissimmee&apos;s premier RN-led CPR and life support training center.
              AHA-aligned certifications with same-day classes and certification available.
            </p>
            <div className="flex items-center gap-3">
              {["ri-facebook-fill", "ri-instagram-line", "ri-twitter-x-line", "ri-linkedin-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-600 hover:border-brand-gold hover:text-brand-gold transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-brand-gold font-semibold text-xs uppercase tracking-widest mb-5">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 text-sm hover:text-brand-gold transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h4 className="text-brand-gold font-semibold text-xs uppercase tracking-widest mb-5">
              Our Courses
            </h4>
            <ul className="space-y-2.5">
              {courses.map((course) => (
                <li key={course}>
                  <Link
                    to="/courses"
                    className="text-gray-400 text-sm hover:text-brand-gold transition-colors cursor-pointer"
                  >
                    {course}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-brand-gold font-semibold text-xs uppercase tracking-widest mb-5">
              Contact
            </h4>
            <div className="space-y-4 mb-6">
              <div className="flex gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-brand-gold mt-0.5">
                  <i className="ri-map-pin-line text-sm" />
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">
                  1627 East Vine Street, Suite 203<br />
                  Kissimmee, FL 34744
                </p>
              </div>
              <div className="flex gap-3 items-center">
                <div className="w-5 h-5 flex items-center justify-center text-brand-gold">
                  <i className="ri-mail-line text-sm" />
                </div>
                <a
                  href="mailto:cardiocraftcpr@gmail.com"
                  className="text-gray-400 text-sm hover:text-brand-gold transition-colors cursor-pointer"
                >
                  cardiocraftcpr@gmail.com
                </a>
              </div>
            </div>
            <Link
              to="/booking#reserve-spot"
              className="block text-center bg-brand-gold text-brand-black font-semibold text-sm px-6 py-3 rounded-md hover:bg-brand-gold-dark transition-colors cursor-pointer whitespace-nowrap"
            >
              Book Now
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">
            &copy; 2026 Cardiocraft CPR. All rights reserved. Kissimmee, FL.
          </p>
          <p className="text-gray-600 text-xs">
            RN-Led Instruction &middot; AHA-Aligned &middot; Same-Day Certification
          </p>
        </div>
      </div>
    </footer>
  );
}
